import React from 'react';
import { Link } from 'react-router-dom';
import './Pakete.css';

const PAKETE = [
  {
    name: 'Free',
    price: 'Kostenlos',
    color: 'var(--text-mid)',
    features: [
      '10 Scans/Monat',
      'Rezepte erstellen & bearbeiten',
      'Private & öffentliche Rezepte',
      '1× Kühlschrank-Scan testen',
    ],
    cta: 'Aktuell aktiv',
    disabled: true,
  },
  {
    name: 'Pro',
    price: '4,99 €/Monat',
    color: 'var(--primary-sage)',
    badge: 'Beliebt',
    features: [
      '100 Scans/Monat',
      'Multi-Upload (bis zu 20 Bilder)',
      'Private & öffentliche Rezepte',
      '10× Kühlschrank-Scan/Monat',
      'Priority-Support',
    ],
    cta: 'Demnächst verfügbar',
    disabled: true,
  },
  {
    name: 'Premium',
    price: '9,99 €/Monat',
    color: 'var(--accent-saffron)',
    features: [
      'Unbegrenzte Scans',
      'Multi-Upload (bis zu 20 Bilder)',
      'Private & öffentliche Rezepte',
      'Unbegrenzter Kühlschrank-Scan',
      'Priority-Support',
      'Früher Zugang zu neuen Features',
    ],
    cta: 'Demnächst verfügbar',
    disabled: true,
  },
];

export default function Pakete() {
  return (
    <div className="container">
      <div className="pakete-page fade-in">
        <h1>Einfache Preise.</h1>
        <p className="pakete-tagline">Fair. Ohne Tricks.</p>
        <p className="pakete-sub">Wähle das passende Paket für deine Bedürfnisse</p>

        <div className="pakete-grid">
          {PAKETE.map(p => (
            <div key={p.name} className="paket-card" style={{ '--accent': p.color }}>
              {p.badge && <span className="paket-badge">{p.badge}</span>}
              <h2 className="paket-name" style={{ color: p.color }}>{p.name}</h2>
              <div className="paket-price">{p.price}</div>
              <ul className="paket-features">
                {p.features.map(f => (
                  <li key={f}><span className="paket-check">✓</span> {f}</li>
                ))}
              </ul>
              <button className="paket-cta" disabled={p.disabled} style={{ background: p.disabled ? 'var(--border)' : p.color }}>
                {p.cta}
              </button>
            </div>
          ))}
        </div>

        <p className="pakete-hint">
          Das Zahlungssystem wird in Kürze freigeschaltet. Bei Fragen wende dich an den Administrator.
        </p>

        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
          <Link to="/upload" className="btn btn-secondary">← Zurück zum Scanner</Link>
        </div>
      </div>
    </div>
  );
}
